import { css } from 'styled-components';
const centeredStyles = css(["right:auto;left:50%;transform:translateX(-50%);align-items:center;"]);
const rightStyles = css(["right:0;left:auto;transform:none;align-items:flex-end;"]);
const leftStyles = css(["right:auto;left:0;transform:none;align-items:flex-start;"]);

/**
 * Where the Spotlight wrapper sits inside the iframe, to match the side the
 * host page puts the iframe on.
 */
export const getSpotlightPositionAlignmentStyles = position => {
  if (position === 'right') return rightStyles;
  if (position === 'left') return leftStyles;
  return centeredStyles;
};